import React, { useState } from 'react';
import { ArrowLeft, Download, Calendar, LineChart, TrendingUp, Award, Target, Users, BookOpen, BarChart3 } from 'lucide-react';
import { StarField } from '../components/Background/StarField';
export function ClassroomPage() {
  const [timeRange, setTimeRange] = useState('week');
  const [selectedGrade, setSelectedGrade] = useState<'all' | 'grade7' | 'grade8' | 'grade9'>('all');
  // 模拟数据 - 基于原型图
  const data = {
    overview: {
      totalClasses: 1386,
      participatingTeachers: 306,
      teachingAnalysisCount: 1234,
      averageScore: 96,
      correctRate: 91,
      goodRate: 95,
      discussionRate: 90
    },
    classTypeDistribution: [{
      type: '自主探究型',
      percentage: 45,
      color: '#38BDF8'
    }, {
      type: '师生交互型',
      percentage: 55,
      color: '#F472B6'
    }, {
      type: '教师主导型',
      percentage: 5,
      color: '#A78BFA'
    }],
    teachingStructure: [{
      name: '教师讲授',
      percentage: 7.38,
      color: '#38BDF8'
    }, {
      name: '合作学习',
      percentage: 8.75,
      color: '#F472B6'
    }, {
      name: '展示工具',
      percentage: 10.86,
      color: '#A78BFA'
    }, {
      name: '自主学习',
      percentage: 32.08,
      color: '#FB923C'
    }, {
      name: '师生互动',
      percentage: 6.83,
      color: '#22C55E'
    }, {
      name: '其他',
      percentage: 34.1,
      color: '#94A3B8'
    }],
    thinkingCultivation: {
      initial: [{
        level: '记忆',
        percentage: 33.5
      }, {
        level: '理解',
        percentage: 52.3
      }, {
        level: '应用',
        percentage: 67.5
      }],
      advanced: [{
        level: '分析',
        percentage: 42.6
      }, {
        level: '评价',
        percentage: 38.2
      }, {
        level: '创造',
        percentage: 29.8
      }]
    },
    studentBehavior: {
      participation: 58.9,
      focusRate: 52.3,
      activeStudy: 58.33
    },
    teacherAbility: {
      teachingSkill: 76.95,
      classManagement: 75.69,
      teachingDesign: 74.79
    },
    teacherComprehensiveAbility: [{
      range: '91-100分',
      count: 66
    }, {
      range: '86-90分',
      count: 263
    }, {
      range: '81-85分',
      count: 411
    }, {
      range: '76-80分',
      count: 1308
    }, {
      range: '71-75分',
      count: 556
    }, {
      range: '61-70分',
      count: 278
    }, {
      range: '60分以下',
      count: 39
    }],
    teacherRanking: [{
      rank: 1,
      subject: '政治',
      score: 79.6,
      change: 0
    }, {
      rank: 2,
      subject: '生物',
      score: 79.47,
      change: 0
    }, {
      rank: 3,
      subject: '化学',
      score: 78.87,
      change: 1.2
    }, {
      rank: 4,
      subject: '语文',
      score: 78.37,
      change: 0
    }, {
      rank: 5,
      subject: '历史',
      score: 78.08,
      change: 0
    }, {
      rank: 6,
      subject: '科学',
      score: 77.99,
      change: 0
    }, {
      rank: 7,
      subject: '道德与法治',
      score: 77.83,
      change: 0
    }, {
      rank: 8,
      subject: '数学',
      score: 77.21,
      change: 0
    }, {
      rank: 9,
      subject: '地理',
      score: 77.18,
      change: 0
    }, {
      rank: 10,
      subject: '物理',
      score: 75.92,
      change: 0
    }],
    subjectParticipation: [{
      subject: '政治',
      classAnalysis: 180,
      participation: 180,
      teaching: 180
    }, {
      subject: '生物',
      classAnalysis: 180,
      participation: 180,
      teaching: 180
    }, {
      subject: '化学',
      classAnalysis: 180,
      participation: 180,
      teaching: 180
    }, {
      subject: '语文',
      classAnalysis: 180,
      participation: 180,
      teaching: 180
    }, {
      subject: '历史',
      classAnalysis: 180,
      participation: 180,
      teaching: 180
    }, {
      subject: '科学',
      classAnalysis: 180,
      participation: 180,
      teaching: 180
    }, {
      subject: '英语',
      classAnalysis: 180,
      participation: 180,
      teaching: 180
    }]
  };
  return <div className="relative w-full min-h-screen bg-[#0B1120] overflow-auto" data-id="element-651">
      {/* Background */}
      <StarField data-id="element-652" />

      {/* Header */}
      <header className="sticky top-0 z-50 bg-gradient-to-b from-[#0B1120] to-[#0B1120]/95 backdrop-blur-sm border-b border-[#38BDF8]/20" data-id="element-653">
        <div className="px-8 py-4" data-id="element-654">
          <div className="flex items-center justify-between" data-id="element-655">
            {/* Left: Back & Title */}
            <div className="flex items-center gap-6" data-id="element-656">
              <button onClick={() => window.history.back()} className="p-2 glass-panel rounded-lg hover:bg-white/10 transition-colors" data-id="element-657">
                <ArrowLeft className="w-5 h-5 text-gray-400" data-id="element-658" />
              </button>
              <div data-id="element-659">
                <h1 className="text-2xl font-bold text-white flex items-center gap-3" data-id="element-660">
                  <div className="w-10 h-10 rounded-xl bg-[#38BDF8]/20 flex items-center justify-center border border-[#38BDF8]/30" data-id="element-661">
                    <LineChart className="w-6 h-6 text-[#38BDF8]" data-id="element-662" />
                  </div>
                  易教·慧眼 课堂洞察
                </h1>
                <p className="text-sm text-gray-400 mt-1" data-id="element-663">
                  精准观测 · 智能分析 · 持续优化
                </p>
              </div>
            </div>

            {/* Right: Actions */}
            <div className="flex items-center gap-4" data-id="element-664">
              <div className="flex items-center gap-2 glass-panel px-3 py-2 rounded-lg border border-white/10" data-id="element-665">
                <Calendar className="w-4 h-4 text-gray-400" data-id="element-666" />
                <select value={timeRange} onChange={e => setTimeRange(e.target.value)} className="bg-transparent text-white text-sm focus:outline-none" data-id="element-667">
                  <option value="week" data-id="element-668">本周</option>
                  <option value="month" data-id="element-669">本月</option>
                  <option value="semester" data-id="element-670">本学期</option>
                </select>
              </div>
              <button className="flex items-center gap-2 glass-panel px-4 py-2 rounded-lg hover:bg-white/10 transition-colors border border-white/10" data-id="element-671">
                <Download className="w-4 h-4 text-gray-400" data-id="element-672" />
                <span className="text-white text-sm" data-id="element-673">导出报告</span>
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="px-8 py-6" data-id="element-674">
        {/* Top Stats Bar */}
        <div className="grid grid-cols-4 gap-4 mb-6" data-id="element-675">
          <div className="glass-panel p-4 rounded-xl border border-white/10" data-id="element-676">
            <div className="flex items-center justify-between" data-id="element-677">
              <div data-id="element-678">
                <div className="text-xs text-gray-400 mb-1" data-id="element-679">课堂分析总数</div>
                <div className="text-3xl font-bold text-[#38BDF8]" data-id="element-680">
                  {data.overview.totalClasses}
                </div>
              </div>
              <BookOpen className="w-8 h-8 text-[#38BDF8]/30" data-id="element-681" />
            </div>
          </div>
          <div className="glass-panel p-4 rounded-xl border border-white/10" data-id="element-682">
            <div className="flex items-center justify-between" data-id="element-683">
              <div data-id="element-684">
                <div className="text-xs text-gray-400 mb-1" data-id="element-685">参与教师人数</div>
                <div className="text-3xl font-bold text-green-400" data-id="element-686">
                  {data.overview.participatingTeachers}
                </div>
              </div>
              <Users className="w-8 h-8 text-green-400/30" data-id="element-687" />
            </div>
          </div>
          <div className="glass-panel p-4 rounded-xl border border-white/10" data-id="element-688">
            <div className="flex items-center justify-between" data-id="element-689">
              <div data-id="element-690">
                <div className="text-xs text-gray-400 mb-1" data-id="element-691">教学分析数量</div>
                <div className="text-3xl font-bold text-purple-400" data-id="element-692">
                  {data.overview.teachingAnalysisCount}
                </div>
              </div>
              <BarChart3 className="w-8 h-8 text-purple-400/30" data-id="element-693" />
            </div>
          </div>
          <div className="glass-panel p-4 rounded-xl border border-white/10" data-id="element-694">
            <div className="flex items-center justify-between" data-id="element-695">
              <div data-id="element-696">
                <div className="text-xs text-gray-400 mb-1" data-id="element-697">平均得分</div>
                <div className="text-3xl font-bold text-orange-400" data-id="element-698">
                  {data.overview.averageScore}
                </div>
              </div>
              <Award className="w-8 h-8 text-orange-400/30" data-id="element-699" />
            </div>
          </div>
        </div>

        {/* Main Grid Layout */}
        <div className="grid grid-cols-12 gap-6" data-id="element-700">
          {/* Left Column - Class Type & Structure */}
          <div className="col-span-3 space-y-6" data-id="element-701">
            {/* Class Type Distribution */}
            <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-702">
              <h3 className="text-white font-bold mb-4 flex items-center gap-2" data-id="element-703">
                <div className="w-1 h-5 bg-[#38BDF8] rounded-full" data-id="element-704"></div>
                课堂类型分布
              </h3>
              <div className="space-y-4" data-id="element-705">
                {data.classTypeDistribution.map((type, index) => <div key={index} data-id="element-706">
                    <div className="flex items-center justify-between mb-2" data-id="element-707">
                      <span className="text-white text-sm" data-id="element-708">{type.type}</span>
                      <span className="text-[#38BDF8] font-bold" data-id="element-709">
                        {type.percentage}%
                      </span>
                    </div>
                    <div className="h-2 bg-white/5 rounded-full overflow-hidden" data-id="element-710">
                      <div className="h-full rounded-full" style={{
                    width: `${type.percentage}%`,
                    backgroundColor: type.color
                  }} data-id="element-711"></div>
                    </div>
                  </div>)}
              </div>
            </div>

            {/* Teaching Structure */}
            <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-712">
              <h3 className="text-white font-bold mb-4 flex items-center gap-2" data-id="element-713">
                <div className="w-1 h-5 bg-[#38BDF8] rounded-full" data-id="element-714"></div>
                教学结构时长分布
              </h3>
              <div className="relative w-48 h-48 mx-auto mb-4" data-id="element-715">
                <svg viewBox="0 0 200 200" className="transform -rotate-90" data-id="element-716">
                  {data.teachingStructure.map((item, index, arr) => {
                  const total = arr.reduce((sum, i) => sum + i.percentage, 0);
                  const startAngle = arr.slice(0, index).reduce((sum, i) => sum + i.percentage / total * 360, 0);
                  const angle = item.percentage / total * 360;
                  const startRad = startAngle * Math.PI / 180;
                  const endRad = (startAngle + angle) * Math.PI / 180;
                  const largeArc = angle > 180 ? 1 : 0;
                  const x1 = 100 + 80 * Math.cos(startRad);
                  const y1 = 100 + 80 * Math.sin(startRad);
                  const x2 = 100 + 80 * Math.cos(endRad);
                  const y2 = 100 + 80 * Math.sin(endRad);
                  return <path key={index} d={`M 100 100 L ${x1} ${y1} A 80 80 0 ${largeArc} 1 ${x2} ${y2} Z`} fill={item.color} opacity="0.8" data-id="element-717" />;
                })}
                  <circle cx="100" cy="100" r="50" fill="#0B1120" data-id="element-718" />
                </svg>
              </div>
              <div className="space-y-2" data-id="element-719">
                {data.teachingStructure.map((item, index) => <div key={index} className="flex items-center justify-between text-xs" data-id="element-720">
                    <div className="flex items-center gap-2" data-id="element-721">
                      <div className="w-2 h-2 rounded-full" style={{
                    backgroundColor: item.color
                  }} data-id="element-722"></div>
                      <span className="text-gray-300" data-id="element-723">{item.name}</span>
                    </div>
                    <span className="text-white font-bold" data-id="element-724">
                      {item.percentage}%
                    </span>
                  </div>)}
              </div>
            </div>

            {/* Student Behavior */}
            <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-725">
              <h3 className="text-white font-bold mb-4 flex items-center gap-2" data-id="element-726">
                <div className="w-1 h-5 bg-[#38BDF8] rounded-full" data-id="element-727"></div>
                学生学习行为分析
              </h3>
              <div className="space-y-4" data-id="element-728">
                <div className="text-center" data-id="element-729">
                  <div className="relative w-32 h-32 mx-auto mb-2" data-id="element-730">
                    <svg viewBox="0 0 100 100" className="transform -rotate-90" data-id="element-731">
                      <circle cx="50" cy="50" r="40" fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth="8" data-id="element-732" />
                      <circle cx="50" cy="50" r="40" fill="none" stroke="#38BDF8" strokeWidth="8" strokeDasharray={`${data.studentBehavior.participation / 100 * 251.2} 251.2`} strokeLinecap="round" data-id="element-733" />
                    </svg>
                    <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-734">
                      <div className="text-2xl font-bold text-[#38BDF8]" data-id="element-735">
                        {data.studentBehavior.participation}%
                      </div>
                      <div className="text-xs text-gray-400" data-id="element-736">参与度</div>
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-3" data-id="element-737">
                  <div className="text-center p-3 bg-white/5 rounded-lg" data-id="element-738">
                    <div className="text-xl font-bold text-green-400" data-id="element-739">
                      {data.studentBehavior.focusRate}%
                    </div>
                    <div className="text-xs text-gray-400 mt-1" data-id="element-740">抬头率</div>
                  </div>
                  <div className="text-center p-3 bg-white/5 rounded-lg" data-id="element-741">
                    <div className="text-xl font-bold text-purple-400" data-id="element-742">
                      {data.studentBehavior.activeStudy}%
                    </div>
                    <div className="text-xs text-gray-400 mt-1" data-id="element-743">主动学习</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Center Column - Teacher Ability & Trends */}
          <div className="col-span-6 space-y-6" data-id="element-744">
            {/* Teacher Ability Overview */}
            <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-745">
              <h3 className="text-white font-bold mb-6 flex items-center gap-2" data-id="element-746">
                <Target className="w-5 h-5 text-[#38BDF8]" data-id="element-747" />
                教师能力评估
              </h3>
              <div className="grid grid-cols-3 gap-6" data-id="element-748">
                <div className="text-center" data-id="element-749">
                  <div className="relative w-32 h-32 mx-auto mb-3" data-id="element-750">
                    <svg viewBox="0 0 100 100" className="transform -rotate-90" data-id="element-751">
                      <circle cx="50" cy="50" r="40" fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth="8" data-id="element-752" />
                      <circle cx="50" cy="50" r="40" fill="none" stroke="#38BDF8" strokeWidth="8" strokeDasharray={`${data.teacherAbility.teachingSkill / 100 * 251.2} 251.2`} strokeLinecap="round" data-id="element-753" />
                    </svg>
                    <div className="absolute inset-0 flex items-center justify-center" data-id="element-754">
                      <div className="text-2xl font-bold text-[#38BDF8]" data-id="element-755">
                        {data.teacherAbility.teachingSkill.toFixed(1)}
                      </div>
                    </div>
                  </div>
                  <div className="text-sm text-white font-medium" data-id="element-756">
                    教师教学素养能力
                  </div>
                  <div className="text-xs text-gray-400 mt-1" data-id="element-757">
                    平均得分: {data.teacherAbility.teachingSkill.toFixed(2)}
                  </div>
                </div>
                <div className="text-center" data-id="element-758">
                  <div className="relative w-32 h-32 mx-auto mb-3" data-id="element-759">
                    <svg viewBox="0 0 100 100" className="transform -rotate-90" data-id="element-760">
                      <circle cx="50" cy="50" r="40" fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth="8" data-id="element-761" />
                      <circle cx="50" cy="50" r="40" fill="none" stroke="#F472B6" strokeWidth="8" strokeDasharray={`${data.teacherAbility.classManagement / 100 * 251.2} 251.2`} strokeLinecap="round" data-id="element-762" />
                    </svg>
                    <div className="absolute inset-0 flex items-center justify-center" data-id="element-763">
                      <div className="text-2xl font-bold text-[#F472B6]" data-id="element-764">
                        {data.teacherAbility.classManagement.toFixed(1)}
                      </div>
                    </div>
                  </div>
                  <div className="text-sm text-white font-medium" data-id="element-765">
                    教师课堂管理能力
                  </div>
                  <div className="text-xs text-gray-400 mt-1" data-id="element-766">
                    平均得分: {data.teacherAbility.classManagement.toFixed(2)}
                  </div>
                </div>
                <div className="text-center" data-id="element-767">
                  <div className="relative w-32 h-32 mx-auto mb-3" data-id="element-768">
                    <svg viewBox="0 0 100 100" className="transform -rotate-90" data-id="element-769">
                      <circle cx="50" cy="50" r="40" fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth="8" data-id="element-770" />
                      <circle cx="50" cy="50" r="40" fill="none" stroke="#A78BFA" strokeWidth="8" strokeDasharray={`${data.teacherAbility.teachingDesign / 100 * 251.2} 251.2`} strokeLinecap="round" data-id="element-771" />
                    </svg>
                    <div className="absolute inset-0 flex items-center justify-center" data-id="element-772">
                      <div className="text-2xl font-bold text-[#A78BFA]" data-id="element-773">
                        {data.teacherAbility.teachingDesign.toFixed(1)}
                      </div>
                    </div>
                  </div>
                  <div className="text-sm text-white font-medium" data-id="element-774">
                    教师教学设计能力
                  </div>
                  <div className="text-xs text-gray-400 mt-1" data-id="element-775">
                    平均得分: {data.teacherAbility.teachingDesign.toFixed(2)}
                  </div>
                </div>
              </div>
            </div>

            {/* Teacher Comprehensive Ability Distribution */}
            <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-776">
              <h3 className="text-white font-bold mb-4 flex items-center gap-2" data-id="element-777">
                <BarChart3 className="w-5 h-5 text-[#38BDF8]" data-id="element-778" />
                教师综合能力分布情况
              </h3>
              <div className="space-y-3" data-id="element-779">
                {data.teacherComprehensiveAbility.map((item, index) => <div key={index} className="flex items-center gap-4" data-id="element-780">
                    <div className="w-24 text-gray-400 text-sm" data-id="element-781">
                      {item.range}
                    </div>
                    <div className="flex-1 h-8 bg-white/5 rounded-full overflow-hidden" data-id="element-782">
                      <div className="h-full bg-gradient-to-r from-[#38BDF8] to-[#0EA5E9] rounded-full flex items-center justify-end pr-3" style={{
                    width: `${item.count / Math.max(...data.teacherComprehensiveAbility.map(i => i.count)) * 100}%`
                  }} data-id="element-783">
                        <span className="text-white text-sm font-bold" data-id="element-784">
                          {item.count}
                        </span>
                      </div>
                    </div>
                  </div>)}
              </div>
            </div>

            {/* Thinking Cultivation */}
            <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-785">
              <h3 className="text-white font-bold mb-4 flex items-center gap-2" data-id="element-786">
                <div className="w-1 h-5 bg-[#38BDF8] rounded-full" data-id="element-787"></div>
                课堂思维培养分析
              </h3>
              <div className="grid grid-cols-2 gap-6" data-id="element-788">
                <div data-id="element-789">
                  <h4 className="text-sm text-gray-400 mb-3" data-id="element-790">初始思维阶段</h4>
                  <div className="space-y-3" data-id="element-791">
                    {data.thinkingCultivation.initial.map((item, index) => <div key={index} data-id="element-792">
                        <div className="flex items-center justify-between mb-1" data-id="element-793">
                          <span className="text-white text-sm" data-id="element-794">
                            {item.level}
                          </span>
                          <span className="text-[#38BDF8] font-bold text-sm" data-id="element-795">
                            {item.percentage}%
                          </span>
                        </div>
                        <div className="h-2 bg-white/5 rounded-full overflow-hidden" data-id="element-796">
                          <div className="h-full bg-gradient-to-r from-[#38BDF8] to-[#0EA5E9] rounded-full" style={{
                        width: `${item.percentage}%`
                      }} data-id="element-797"></div>
                        </div>
                      </div>)}
                  </div>
                </div>
                <div data-id="element-798">
                  <h4 className="text-sm text-gray-400 mb-3" data-id="element-799">高阶思维阶段</h4>
                  <div className="space-y-3" data-id="element-800">
                    {data.thinkingCultivation.advanced.map((item, index) => <div key={index} data-id="element-801">
                        <div className="flex items-center justify-between mb-1" data-id="element-802">
                          <span className="text-white text-sm" data-id="element-803">
                            {item.level}
                          </span>
                          <span className="text-[#F472B6] font-bold text-sm" data-id="element-804">
                            {item.percentage}%
                          </span>
                        </div>
                        <div className="h-2 bg-white/5 rounded-full overflow-hidden" data-id="element-805">
                          <div className="h-full bg-gradient-to-r from-[#F472B6] to-[#EC4899] rounded-full" style={{
                        width: `${item.percentage}%`
                      }} data-id="element-806"></div>
                        </div>
                      </div>)}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Rankings & Participation */}
          <div className="col-span-3 space-y-6" data-id="element-807">
            {/* Teacher Ranking */}
            <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-808">
              <h3 className="text-white font-bold mb-4 flex items-center gap-2" data-id="element-809">
                <Award className="w-5 h-5 text-[#38BDF8]" data-id="element-810" />
                教师综合能力排名
              </h3>
              <div className="space-y-2" data-id="element-811">
                {data.teacherRanking.slice(0, 10).map(teacher => <div key={teacher.rank} className="flex items-center justify-between p-3 bg-white/5 rounded-lg hover:bg-white/10 transition-colors" data-id="element-812">
                    <div className="flex items-center gap-3" data-id="element-813">
                      <div className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold ${teacher.rank === 1 ? 'bg-yellow-400/20 text-yellow-400' : teacher.rank === 2 ? 'bg-gray-400/20 text-gray-400' : teacher.rank === 3 ? 'bg-orange-400/20 text-orange-400' : 'bg-[#38BDF8]/20 text-[#38BDF8]'}`} data-id="element-814">
                        {teacher.rank}
                      </div>
                      <span className="text-white text-sm" data-id="element-815">
                        {teacher.subject}
                      </span>
                    </div>
                    <div className="flex items-center gap-2" data-id="element-816">
                      <span className="text-[#38BDF8] font-bold text-sm" data-id="element-817">
                        {teacher.score}
                      </span>
                      {teacher.change > 0 && <div className="flex items-center gap-1 text-green-400 text-xs" data-id="element-818">
                          <TrendingUp className="w-3 h-3" data-id="element-819" />
                          <span data-id="element-820">+{teacher.change}</span>
                        </div>}
                    </div>
                  </div>)}
              </div>
            </div>

            {/* Subject Participation */}
            <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-821">
              <h3 className="text-white font-bold mb-4 flex items-center gap-2" data-id="element-822">
                <Users className="w-5 h-5 text-[#38BDF8]" data-id="element-823" />
                教师参与情况排名
              </h3>
              <div className="space-y-3" data-id="element-824">
                <div className="flex items-center justify-between text-xs text-gray-400 pb-2 border-b border-white/10" data-id="element-825">
                  <span data-id="element-826">学科名称</span>
                  <span data-id="element-827">课堂分析数量</span>
                </div>
                {data.subjectParticipation.map((subject, index) => <div key={index} className="flex items-center justify-between" data-id="element-828">
                    <span className="text-white text-sm" data-id="element-829">
                      {subject.subject}
                    </span>
                    <div className="flex items-center gap-2" data-id="element-830">
                      <div className="w-20 h-2 bg-white/5 rounded-full overflow-hidden" data-id="element-831">
                        <div className="h-full bg-gradient-to-r from-[#38BDF8] to-[#0EA5E9] rounded-full" style={{
                      width: '100%'
                    }} data-id="element-832"></div>
                      </div>
                      <span className="text-[#38BDF8] font-bold text-sm w-8 text-right" data-id="element-833">
                        {subject.classAnalysis}
                      </span>
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>;
}